import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import SortBy from "../components/SortBy";
import DownloadBtn from "../components/DownloadBtn";
import CorporateDeclinedTable from "../components/IndividualDeclinedTable";
// import StudenInProgressTable from '../components/StudenInProgressTable';
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCorporateApplicationApproval,
  setUpdateCorporatesStatus,
  setUpdateCorporatesPagination,
  setUpdateCorporatesPageSize,
} from "../redux/slices/corporateApplicationApprovalSlice";
import CorporateApprovedTable from "../components/CorporateApprovalTable";
import CorporatePendingTable from "../components/CorporatePendingTable";

const Corporate = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const errorsArray = Array.isArray(error) ? error : [error];
  const corporateApplication = useSelector(
    (state) => state?.corporateApplicationApproval
  );

  const getAllCorporateApplication = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await dispatch(fetchCorporateApplicationApproval());
      if (response?.payload?.name === "AxiosError") {
        setLoading(false);
        setError(
          response?.payload?.response?.data?.errors?.map((errors) => errors) ||
            response?.payload?.response?.data?.error?.description ||
            "Failed to get Individual Applications"
        );
      }
      setLoading(false);
    } catch (error) {
      setError(
        error?.payload?.message ||
          "Failed to get Individual Applications, please check your network"
      );
    }
  }, [dispatch]);

  useEffect(() => {
    getAllCorporateApplication();
  }, [getAllCorporateApplication, corporateApplication?.corporatesParams]);

  const handleStatusChange = (status) => {
    dispatch(setUpdateCorporatesStatus(status));
  };

  const handlePagination = (page) => {
    dispatch(setUpdateCorporatesPagination(page));
  };

  const handlePageSize = (size) => {
    dispatch(setUpdateCorporatesPageSize(size));
  };

  const corporateAppData = {
    handlePagination,
    handlePageSize,
    itemsPerPage: corporateApplication?.corporates?.currentPageRecord,
    totalRecord: corporateApplication?.corporates?.totalRecord,
    pageNumber: corporateApplication?.corporatesParams?.page,
    nextPage: corporateApplication?.corporates?.nextPage,
    previousPage: corporateApplication?.corporates?.previousPage,
    pageSize: corporateApplication?.corporatesParams?.pageSize,
  };

  return (
    <Box pt={2} pb={5} minH={"100vh"} px={3}>
      <Flex
        bg={"#FFFFFF"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={"20px"}
        py={2}
        px={3}
        mb={5}
      >
        <Text fontSize={"18px"} fontWeight={"700"} color={"brand.primary"}>
          Corporate Application
        </Text>
        <Flex
          flexDirection={["column", "column", "row"]}
          alignItems={"center"}
          gap={[3, null, null]}
        >
          <SortBy />
          <DownloadBtn />
        </Flex>
      </Flex>
      <Tabs variant="unstyled">
        <TabList
          gap={"20px"}
          flexDirection={["column", "row", "row"]}
          pb={4}
          justifyContent={["center", "flex-start", "flex-start"]}
          alignItems={"center"}
        >
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Pending")}
          >
            Pending
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Approved")}
          >
            Approved
          </Tab>
          <Tab
            _selected={{ color: "#FFFFFF", bg: "#23A455CC" }}
            bg={"#E9E9E9"}
            w={["100%", "18%", "18%", "18%"]}
            borderRadius={"4px"}
            lineHeight={"-0.25px"}
            color={"#54595F"}
            onClick={() => handleStatusChange("Declined")}
          >
            Declined
          </Tab>
          {/* <Tab _selected={{ color: '#FFFFFF', bg: '#D11A2A' }}
         bg={'#E9E9E9'} w={['100%', '18%', '18%', '18%']}  borderRadius={'4px'} lineHeight={'-0.25px'} color={'#54595F'}
        >In-progress</Tab> */}
        </TabList>

        <TabPanels bg={"#FFFFFF"}>
          <TabPanel>
            <CorporatePendingTable
              CorporateApplication={corporateApplication}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...corporateAppData}
            />
          </TabPanel>
          <TabPanel>
            <CorporateApprovedTable
              CorporateApplication={corporateApplication}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...corporateAppData}
            />
          </TabPanel>
          <TabPanel>
            <CorporateDeclinedTable
              CorporateApplication={corporateApplication}
              loading={loading}
              errorsArray={errorsArray}
              error={error}
              {...corporateAppData}
            />
          </TabPanel>
          {/* <TabPanel>
          <StudenInProgressTable />
        </TabPanel> */}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Corporate;
